/* ============================================================================
   Bro Glo — Merch PDP JavaScript
   ============================================================================
   Gallery uses scrollLeft (NOT translateX) for bulletproof navigation.
   Color + size filtering, cross-availability, ATC, pricing, shipping bar,
   cross-sell, ticker, accordion, sticky ATC.
   Zero dependencies · ADA compliant · Fast.
   ============================================================================ */

(function () {
  'use strict';

  const BrogloPdpMerch = {

    state: {},

    /* ── Init ── */
    init(sectionId) {
      const data = window.brogloPdpMerchData?.[sectionId];
      if (!data) return;

      const initialVariant = data.variants.find(v => v.id === data.currentVariantId);
      const colorPos = data.colorPos || 2;
      const sizePos = data.sizePos || 1;

      const initialColor = colorPos === 1
        ? (initialVariant?.option1Handle || '')
        : (initialVariant?.option2Handle || '');
      const initialSize = sizePos === 1
        ? (initialVariant?.option1Handle || '')
        : (initialVariant?.option2Handle || '');

      this.state[sectionId] = {
        data,
        currentVariantId: data.currentVariantId,
        currentColor: initialColor,
        currentSize: initialSize,
        colorPos,
        sizePos,
        currentSlide: 0
      };

      this.initGallery(sectionId);
      this.filterGallery(sectionId);
      this.updateSizeAvailability(sectionId);
      this.updateColorAvailability(sectionId);
      this.updatePricing(sectionId);
      this.initStickyAtc(sectionId);
      this.initTickerCycle(sectionId);

      /* URL variant override */
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = parseInt(urlParams.get('variant'));
      if (urlVariantId && urlVariantId !== data.currentVariantId) {
        const urlVariant = data.variants.find(v => v.id === urlVariantId);
        if (urlVariant) {
          const urlColor = colorPos === 1 ? urlVariant.option1Handle : urlVariant.option2Handle;
          const urlSize = sizePos === 1 ? urlVariant.option1Handle : urlVariant.option2Handle;
          const colorBtn = document.querySelector('#BrogloPdp-' + sectionId + ' .broglo-pdp__shade-btn[data-color="' + urlColor + '"]');
          if (colorBtn) this.selectColor(sectionId, colorBtn);
          const sizeBtn = document.querySelector('#BrogloPdp-' + sectionId + ' .broglo-merch__size-btn[data-size="' + urlSize + '"]');
          if (sizeBtn) this.selectSize(sectionId, sizeBtn);
        }
      }
    },

    /* ======================== VARIANT RESOLVER ======================== */
    resolveVariant(sectionId, colorHandle, sizeHandle) {
      const state = this.state[sectionId];
      if (!state) return null;
      const { colorPos, sizePos } = state;
      return state.data.variants.find(v => {
        const vColor = colorPos === 1 ? v.option1Handle : v.option2Handle;
        const vSize = sizePos === 1 ? v.option1Handle : v.option2Handle;
        return vColor === colorHandle && vSize === sizeHandle;
      }) || null;
    },

    applyVariant(sectionId) {
      const state = this.state[sectionId];
      if (!state) return;
      const variant = this.resolveVariant(sectionId, state.currentColor, state.currentSize);
      const atcBtn = document.getElementById('brogloPdpAtcBtn-' + sectionId);

      if (variant) {
        state.currentVariantId = variant.id;
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        if (atcBtn) {
          if (variant.available) {
            atcBtn.disabled = false;
            atcBtn.innerHTML = 'Add to Cart<span class="broglo-pdp__atc-price" id="brogloPdpAtcPrice-' + sectionId + '"> \u2014 ' + this.formatMoney(variant.price) + '</span>';
          } else {
            atcBtn.disabled = true;
            atcBtn.innerHTML = 'Sold Out';
          }
        }
      } else {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.innerHTML = 'Unavailable'; }
      }
      this.updatePricing(sectionId);
    },

    /* ======================== COLOR SELECTION ======================== */
    selectColor(sectionId, btn) {
      const state = this.state[sectionId];
      if (!state) return;
      if (btn.classList.contains('unavailable')) return;

      const colorHandle = btn.dataset.color;
      const colorName = btn.dataset.colorName;
      state.currentColor = colorHandle;

      const section = document.getElementById('BrogloPdp-' + sectionId);
      if (section) section.dataset.color = colorHandle;

      const colorsContainer = document.getElementById('brogloPdpColors-' + sectionId);
      if (colorsContainer) {
        colorsContainer.querySelectorAll('.broglo-pdp__shade-btn').forEach(function(b) {
          b.classList.toggle('active', b === btn);
        });
      }

      const badge = document.getElementById('brogloPdpBadgeLeft-' + sectionId);
      if (badge) badge.textContent = colorName;

      this.filterGallery(sectionId);
      this.updateSizeAvailability(sectionId);

      const stickyName = document.getElementById('brogloPdpStickyName-' + sectionId);
      if (stickyName) stickyName.textContent = state.data.productTitle + ' \u2014 ' + colorName;

      this.applyVariant(sectionId);
      this.announce(sectionId, colorName + ' color selected.');
    },

    /* ======================== SIZE SELECTION ======================== */
    selectSize(sectionId, btn) {
      const state = this.state[sectionId];
      if (!state) return;
      if (btn.classList.contains('unavailable')) return;

      const sizeHandle = btn.dataset.size;
      const sizeName = btn.dataset.sizeName;
      state.currentSize = sizeHandle;

      const section = document.getElementById('BrogloPdp-' + sectionId);
      if (section) section.dataset.size = sizeHandle;

      const sizesContainer = document.getElementById('brogloPdpSizes-' + sectionId);
      if (sizesContainer) {
        sizesContainer.querySelectorAll('.broglo-merch__size-btn').forEach(function(b) {
          var isActive = b === btn;
          b.classList.toggle('active', isActive);
          b.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
      }

      this.updateColorAvailability(sectionId);
      this.filterGallery(sectionId);
      this.applyVariant(sectionId);
      this.announce(sectionId, sizeName + ' size selected.');
    },

    /* ======================== SIZE AVAILABILITY ======================== */
    updateSizeAvailability(sectionId) {
      var self = this;
      const state = this.state[sectionId];
      if (!state) return;
      const sizesContainer = document.getElementById('brogloPdpSizes-' + sectionId);
      if (!sizesContainer) return;
      sizesContainer.querySelectorAll('.broglo-merch__size-btn').forEach(function(btn) {
        const variant = self.resolveVariant(sectionId, state.currentColor, btn.dataset.size);
        const isAvailable = variant && variant.available;
        btn.classList.toggle('unavailable', !isAvailable);
        btn.setAttribute('aria-disabled', (!isAvailable).toString());
      });
    },

    /* ======================== COLOR AVAILABILITY ======================== */
    updateColorAvailability(sectionId) {
      var self = this;
      const state = this.state[sectionId];
      if (!state) return;
      const colorsContainer = document.getElementById('brogloPdpColors-' + sectionId);
      if (!colorsContainer) return;
      colorsContainer.querySelectorAll('.broglo-pdp__shade-btn').forEach(function(btn) {
        const variant = self.resolveVariant(sectionId, btn.dataset.color, state.currentSize);
        const isAvailable = variant && variant.available;
        btn.classList.toggle('unavailable', !isAvailable);
        btn.setAttribute('aria-disabled', (!isAvailable).toString());
      });
    },

    /* ======================== CROSS-SELL ======================== */
    toggleXsell(sectionId, card) {
      const isChecked = card.classList.contains('broglo-acc-xsell__card--checked');
      card.classList.toggle('broglo-acc-xsell__card--checked', !isChecked);
      card.setAttribute('aria-checked', (!isChecked).toString());
      this.updatePricing(sectionId);
      const name = card.querySelector('.broglo-acc-xsell__name');
      this.announce(sectionId, (name ? name.textContent : 'item') + (!isChecked ? ' added to' : ' removed from') + ' your order.');
    },

    getXsellTotal(sectionId) {
      const section = document.getElementById('BrogloPdp-' + sectionId);
      if (!section) return 0;
      var total = 0;
      section.querySelectorAll('.broglo-acc-xsell__card--checked').forEach(function(card) {
        total += parseInt(card.dataset.price) || 0;
      });
      return total;
    },

    /* ======================== PRICING ======================== */
    updatePricing(sectionId) {
      const state = this.state[sectionId];
      if (!state) return;
      const variant = this.resolveVariant(sectionId, state.currentColor, state.currentSize);
      if (!variant) return;

      const price = variant.price;
      const compareAt = variant.compareAtPrice || 0;
      const xsellTotal = this.getXsellTotal(sectionId);

      const priceEl = document.getElementById('brogloPdpPrice-' + sectionId);
      if (priceEl) priceEl.textContent = this.formatMoney(price);

      const compareEl = document.getElementById('brogloPdpCompare-' + sectionId);
      if (compareEl) {
        if (compareAt > price) {
          compareEl.textContent = this.formatMoney(compareAt);
          compareEl.classList.add('visible');
        } else { compareEl.classList.remove('visible'); }
      }

      const atcPrice = document.getElementById('brogloPdpAtcPrice-' + sectionId);
      if (atcPrice) atcPrice.innerHTML = ' \u2014 ' + this.formatMoney(price + xsellTotal);

      this.updateShippingBar(sectionId, price + xsellTotal);

      const stickyPrice = document.getElementById('brogloPdpStickyPrice-' + sectionId);
      if (stickyPrice) stickyPrice.textContent = this.formatMoney(price + xsellTotal);
    },

    /* ======================== SHIPPING BAR ======================== */
    updateShippingBar(sectionId, total) {
      const state = this.state[sectionId];
      if (!state) return;
      const threshold = state.data.freeShipThreshold;
      const fill = document.getElementById('brogloPdpShipFill-' + sectionId);
      const text = document.getElementById('brogloPdpShipText-' + sectionId);
      if (!fill || !text) return;
      fill.style.width = Math.min(100, Math.round((total / threshold) * 100)) + '%';
      if (total >= threshold) {
        text.innerHTML = '\uD83C\uDF89 <strong style="color:#2D9B5E">You qualify for free shipping!</strong>';
      } else {
        text.innerHTML = 'Add <strong>' + this.formatMoney(threshold - total) + '</strong> more for free shipping';
      }
    },

    /* ======================== ADD TO CART ======================== */
    addToCart: async function(sectionId) {
      const state = this.state[sectionId];
      if (!state) return;
      const atcBtn = document.getElementById('brogloPdpAtcBtn-' + sectionId);
      if (atcBtn) { atcBtn.setAttribute('aria-disabled', 'true'); atcBtn.setAttribute('aria-busy', 'true'); }

      const items = [{ id: state.currentVariantId, quantity: 1 }];
      const section = document.getElementById('BrogloPdp-' + sectionId);
      if (section) {
        section.querySelectorAll('.broglo-acc-xsell__card--checked').forEach(function(card) {
          var vid = parseInt(card.dataset.variantId);
          if (vid) items.push({ id: vid, quantity: 1 });
        });
      }

      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        });
        if (!response.ok) { var ed = {}; try { ed = await response.json(); } catch(e) {} throw new Error(ed.description || ('HTTP ' + response.status)); }

        if (atcBtn) {
          var origHTML = atcBtn.innerHTML;
          atcBtn.innerHTML = '\u2713 Added to Cart!'; atcBtn.style.background = '#2D9B5E';
          setTimeout(function() { atcBtn.innerHTML = origHTML; atcBtn.style.background = ''; }, 2000);
        }
        this.announce(sectionId, 'Items added to cart successfully.');
        this.refreshCartCount();
        if (window.BWCart && BWCart.refresh) { BWCart.refresh(true); }
        else { var hc = document.querySelector('.header a[href="/cart"], header a[href*="/cart"], .header__icon--cart'); if (hc) hc.click(); else window.location.href = '/cart'; }
      } catch (err) {
        console.error('[Bro Glo Merch ATC] Error:', err);
        if (atcBtn) { var o = atcBtn.innerHTML; atcBtn.innerHTML = 'Error \u2014 try again'; atcBtn.style.background = '#E74C3C'; setTimeout(function() { atcBtn.innerHTML = o; atcBtn.style.background = ''; }, 3000); }
        this.announce(sectionId, 'Error adding to cart. Please try again.');
      } finally {
        if (atcBtn) { atcBtn.removeAttribute('aria-disabled'); atcBtn.removeAttribute('aria-busy'); }
      }
    },

    refreshCartCount: async function() {
      try {
        var resp = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        var cart = await resp.json();
        var count = cart.item_count || 0;
        document.querySelectorAll('.cart-count-bubble span[aria-hidden], .cart-count, [data-cart-count], .js-cart-count').forEach(function(el) { el.textContent = count; });
        document.querySelectorAll('.cart-count-bubble').forEach(function(el) { el.style.display = count > 0 ? '' : 'none'; });
      } catch (e) {}
    },

    /* ======================== GALLERY FILTERING (COLOR + SIZE) ======================== */
    filterGallery(sectionId) {
      const state = this.state[sectionId];
      if (!state) return;
      const section = document.getElementById('BrogloPdp-' + sectionId);
      if (!section) return;

      const slides = section.querySelectorAll('.broglo-pdp__slide');
      const thumbs = section.querySelectorAll('.broglo-pdp__thumb');
      const dots = section.querySelectorAll('.broglo-pdp__dot');
      const currentColor = state.currentColor;
      const currentSize = state.currentSize;

      var hasGroups = false;
      slides.forEach(function(s) {
        if (s.dataset.colorGroup && s.dataset.colorGroup !== 'shared') hasGroups = true;
      });

      if (!hasGroups) {
        slides.forEach(function(s) { s.classList.remove('variant-hidden'); });
        thumbs.forEach(function(t) { t.classList.remove('variant-hidden'); });
        dots.forEach(function(d) { d.classList.remove('variant-hidden'); });
        this.navigateToSlide(sectionId, 0);
        this.updateThumbArrows(sectionId);
        return;
      }

      /* Check if exact color+size combo has dedicated images */
      var hasExactCombo = false;
      slides.forEach(function(s) {
        if (s.dataset.colorGroup === currentColor && s.dataset.sizeGroup === currentSize) hasExactCombo = true;
      });

      var firstVisibleIndex = null;

      function isVisible(el) {
        var elColor = el.dataset.colorGroup || 'shared';
        var elSize = el.dataset.sizeGroup || 'shared';
        if (elColor === 'shared') return true;
        if (hasExactCombo) return elColor === currentColor && elSize === currentSize;
        return elColor === currentColor;
      }

      slides.forEach(function(slide, i) {
        var visible = isVisible(slide);
        slide.classList.toggle('variant-hidden', !visible);
        if (visible && firstVisibleIndex === null) firstVisibleIndex = i;
      });

      thumbs.forEach(function(thumb) { thumb.classList.toggle('variant-hidden', !isVisible(thumb)); });
      dots.forEach(function(dot) { dot.classList.toggle('variant-hidden', !isVisible(dot)); });

      /* Wait for browser to apply display:none before measuring positions */
      var self = this;
      if (firstVisibleIndex !== null) {
        requestAnimationFrame(function() {
          self.navigateToSlide(sectionId, firstVisibleIndex);
        });
      }
      this.updateThumbArrows(sectionId);
    },

    /* ======================== TICKER ======================== */
    initTickerCycle(sectionId) {
      const data = this.state[sectionId]?.data;
      if (!data) return;
      const el = document.getElementById('brogloPdpTicker-' + sectionId);
      var countEl = document.getElementById('brogloPdpTickerCount-' + sectionId);
      if (!el || !countEl) return;

      const cfg = data.tickerCount || {};
      const base = cfg.base || 89, cap = cfg.cap || 400;
      const minInterval = (cfg.minInterval || 25) * 1000, maxInterval = (cfg.maxInterval || 50) * 1000;
      const minInc = cfg.minInc || 1, maxInc = cfg.maxInc || 2;
      const storageKey = 'broglo_merch_ticker_' + data.productId;

      var now = new Date(), day = now.getUTCDay(), diff = day === 0 ? 6 : day - 1;
      var monday = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - diff, 0, 0, 0));
      var mondayTs = monday.getTime();

      var count = base;
      try {
        var stored = JSON.parse(localStorage.getItem(storageKey));
        if (stored && stored.week === mondayTs) {
          count = stored.count || base;
          var elapsed = (Date.now() - (stored.ts || Date.now())) / 1000;
          count = Math.min(cap, Math.floor(count + Math.floor(elapsed / (((cfg.minInterval||25)+(cfg.maxInterval||50))/2)) * ((minInc+maxInc)/2)));
        }
      } catch (e) { count = base; }
      countEl.textContent = count;

      var save = function() { try { localStorage.setItem(storageKey, JSON.stringify({ week: mondayTs, count: count, ts: Date.now() })); } catch (e) {} };
      save();

      var tick = function() {
        if (count >= cap) return;
        count = Math.min(cap, count + Math.floor(Math.random() * (maxInc - minInc + 1)) + minInc);
        countEl = document.getElementById('brogloPdpTickerCount-' + sectionId);
        if (countEl) countEl.textContent = count;
        save();
        setTimeout(tick, Math.floor(Math.random() * (maxInterval - minInterval)) + minInterval);
      };
      setTimeout(tick, Math.floor(Math.random() * (maxInterval - minInterval)) + minInterval);

      var msgs = (data.tickerMessages || []).filter(function(m) { return m && m.trim(); });
      if (msgs.length > 1) {
        var i = 0; el.style.transition = 'opacity 0.3s';
        setInterval(function() {
          i = (i + 1) % msgs.length; el.style.opacity = 0;
          setTimeout(function() {
            el.innerHTML = msgs[i].replace('{count}', '<span id="brogloPdpTickerCount-' + sectionId + '">' + count + '</span>');
            countEl = document.getElementById('brogloPdpTickerCount-' + sectionId);
            el.style.opacity = 1;
          }, 300);
        }, 4000);
      }
    },

    /* ======================== GALLERY (SCROLL-BASED — NO translateX) ======================== */
    /**
     * Gallery navigation uses scrollLeft for BOTH mobile and desktop.
     * Works with overflow:hidden (programmatic scroll still works, no scrollbar).
     * CSS scroll-behavior:smooth handles the animation.
     * This eliminates all translateX percentage math bugs.
     */
    initGallery(sectionId) {
      var self = this;
      const slidesEl = document.getElementById('brogloPdpSlides-' + sectionId);
      if (!slidesEl) return;

      /* Track scroll position to update active indicators */
      slidesEl.addEventListener('scroll', function() {
        var allSlides = Array.from(slidesEl.querySelectorAll('.broglo-pdp__slide'));
        var scrollLeft = slidesEl.scrollLeft;
        var closestIdx = 0;
        var minDist = Infinity;
        allSlides.forEach(function(slide, i) {
          if (slide.classList.contains('variant-hidden')) return;
          var dist = Math.abs(slide.offsetLeft - scrollLeft);
          if (dist < minDist) { minDist = dist; closestIdx = i; }
        });
        self.updateActiveIndicators(sectionId, closestIdx);
      }, { passive: true });
    },

    /**
     * Navigate to a slide by absolute index.
     * Uses scrollLeft — works on both mobile and desktop.
     */
    navigateToSlide(sectionId, absoluteIndex) {
      const state = this.state[sectionId];
      if (!state) return;
      state.currentSlide = absoluteIndex;

      const slidesEl = document.getElementById('brogloPdpSlides-' + sectionId);
      if (!slidesEl) return;

      var allSlides = Array.from(slidesEl.querySelectorAll('.broglo-pdp__slide'));
      var targetSlide = allSlides[absoluteIndex];

      if (targetSlide && !targetSlide.classList.contains('variant-hidden')) {
        slidesEl.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
      } else {
        /* Target is hidden — find first visible slide */
        var firstVisible = allSlides.find(function(s) { return !s.classList.contains('variant-hidden'); });
        if (firstVisible) {
          slidesEl.scrollTo({ left: firstVisible.offsetLeft, behavior: 'smooth' });
          absoluteIndex = allSlides.indexOf(firstVisible);
        }
      }

      this.updateActiveIndicators(sectionId, absoluteIndex);
    },

    /* Update dots + thumbs active state */
    updateActiveIndicators(sectionId, absoluteIndex) {
      const dotsContainer = document.getElementById('brogloPdpDots-' + sectionId);
      if (dotsContainer) {
        dotsContainer.querySelectorAll('.broglo-pdp__dot').forEach(function(dot) {
          dot.classList.toggle('active', parseInt(dot.dataset.slide) === absoluteIndex);
        });
      }

      const thumbsContainer = document.getElementById('brogloPdpThumbs-' + sectionId);
      if (thumbsContainer) {
        thumbsContainer.querySelectorAll('.broglo-pdp__thumb').forEach(function(thumb) {
          var isActive = parseInt(thumb.dataset.slide) === absoluteIndex;
          thumb.classList.toggle('active', isActive);
          if (isActive && !thumb.classList.contains('variant-hidden')) {
            var thumbCenter = thumb.offsetLeft - thumbsContainer.offsetLeft - (thumbsContainer.offsetWidth / 2) + (thumb.offsetWidth / 2);
            thumbsContainer.scrollTo({ left: thumbCenter, behavior: 'smooth' });
          }
        });
      }
    },

    /* ======================== THUMBNAIL SCROLLING ======================== */
    scrollThumbs(sectionId, direction) {
      var thumbsEl = document.getElementById('brogloPdpThumbs-' + sectionId);
      if (!thumbsEl) return;
      thumbsEl.scrollBy({ left: 164 * direction, behavior: 'smooth' });
      var self = this;
      setTimeout(function() { self.updateThumbArrows(sectionId); }, 350);
    },

    updateThumbArrows(sectionId) {
      var thumbsEl = document.getElementById('brogloPdpThumbs-' + sectionId);
      var prevBtn = document.getElementById('brogloPdpThumbPrev-' + sectionId);
      var nextBtn = document.getElementById('brogloPdpThumbNext-' + sectionId);
      if (!thumbsEl) return;
      var maxScroll = thumbsEl.scrollWidth - thumbsEl.clientWidth;
      if (prevBtn) prevBtn.disabled = thumbsEl.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = thumbsEl.scrollLeft >= maxScroll - 2;
    },

    /* ======================== ACCORDION ======================== */
    toggleAccordion(trigger) {
      var content = trigger.nextElementSibling;
      var isOpen = trigger.classList.contains('open');
      trigger.classList.toggle('open');
      content.classList.toggle('open');
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      content.style.maxHeight = isOpen ? '0' : content.scrollHeight + 'px';
    },

    /* ======================== STICKY ATC ======================== */
    initStickyAtc(sectionId) {
      var sticky = document.getElementById('brogloPdpStickyAtc-' + sectionId);
      var atcBtn = document.getElementById('brogloPdpAtcBtn-' + sectionId);
      if (!sticky || !atcBtn) return;
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) sticky.classList.remove('visible');
          else sticky.classList.toggle('visible', entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      observer.observe(atcBtn);
    },

    /* ======================== HELPERS ======================== */
    formatMoney(cents) { return '$' + (cents / 100).toFixed(2); },

    announce(sectionId, message) {
      var el = document.getElementById('brogloPdpSrAnnounce-' + sectionId);
      if (!el) return;
      el.textContent = '';
      requestAnimationFrame(function() { el.textContent = message; });
    }
  };

  window.BrogloPdpMerch = BrogloPdpMerch;

  function autoInit() {
    document.querySelectorAll('[data-pdp-type="merch"]').forEach(function(section) {
      var sectionId = section.dataset.sectionId;
      if (sectionId && window.brogloPdpMerchData?.[sectionId]) BrogloPdpMerch.init(sectionId);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoInit);
  else autoInit();

  /* Click delegation for dots/thumbs */
  document.addEventListener('click', function(e) {
    var dot = e.target.closest('.broglo-pdp__dot');
    if (dot && !dot.classList.contains('variant-hidden')) {
      var sec = dot.closest('[data-pdp-type="merch"]');
      if (sec) BrogloPdpMerch.navigateToSlide(sec.dataset.sectionId, parseInt(dot.dataset.slide));
    }
    var thumb = e.target.closest('.broglo-pdp__thumb');
    if (thumb && !thumb.classList.contains('variant-hidden')) {
      var sec2 = thumb.closest('[data-pdp-type="merch"]');
      if (sec2) BrogloPdpMerch.navigateToSlide(sec2.dataset.sectionId, parseInt(thumb.dataset.slide));
    }
  });
})();
